import request from '@/utils/request'

let PdemandApi = {

  /*新品需求列表*/
  list(data) {
    return request._post('/shop/plus.pdemand.Index/index', data);
},
/*添加新品需求*/
add(data) {
    return request._post('/shop/plus.pdemand.Index/add', data);
},
/*修改新品需求*/
edit(data) {
    return request._post('/shop/plus.pdemand.Index/edit', data);
},
/*删除新品需求*/
del(data) {
    return request._post('/shop/plus.pdemand.Index/del', data);
},
/*新品需求详情*/
detail(data) {
  return request._post('/shop/plus.pdemand.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.pdemand.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.pdemand.Setting/getSetting', data, errorback);
    },
}
export default PdemandApi;



// WEBPACK FOOTER //
// ./src/api/pdemand.js